import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Header from './Header';
import axios from 'axios';
import Footer from './Footer'; 
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { ADD, DLT, REMOVE } from '../redux/actions/action';
import Swal from 'sweetalert2';
import Bannerslider from './Bannerslider';
import Product from './Product';
import { BASE_URL } from '../Config';
import { Helmet } from 'react-helmet';
function Home() {

    const { id } = useParams();
    const token = localStorage.getItem('token');
    const [productList, setProductList] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${BASE_URL}/api/product_list`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setProductList(response.data.product_list);
            } catch (error) {
                console.error('Error fetching product data:', error);
            }
        };
        fetchData();
    }, [id, token, dispatch]);

    const send = (product) => {
        Swal.fire({
            icon: 'success',
            title: `${product.product_name} Item Added to Cart`,
            text: 'Successfully!',
        });
        dispatch(ADD(product));
    };

    

    return (
        <>
        <Helmet>
  <title>Home | EezybreezyU</title>
  <meta name="description" content="Welcome to EezybreezyU homepage, fresh fragrances for car and home." />
</Helmet>

            <Header />
            <Bannerslider />
            <div className="boxed_wrapper">
            <section className="collection-section" style={{ marginTop: "20px"}}>
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-4 col-md-6 col-sm-12 single-column">
                        <div className="single-item wow fadeInLeft animated animated animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInLeft" }}>
                            <div>
                               <img src="assets_web/images/banner/syle-bg-one.jpg" alt="image" style={{borderRadius:"50px 0px 50px 0px",boxShadow:"0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)"}}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 single-column">
                        <div className="single-item wow fadeInRight animated animated animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInRight"}}>
                           <div>
                               <img src="assets_web/images/banner/style-bg-two.jpg" alt="image" style={{borderRadius:"50px 0px 50px 0px", boxShadow:"0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)"}}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 single-column">
                        <div className="single-item wow fadeInRight animated animated animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInRight"}}>
                            <div>
                               <img src="assets_web/images/banner/style-bg-three.jpg" alt="image" style={{borderRadius:"50px 0px 50px 0px", boxShadow:"0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)"}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="py-5" style={{ background: "linear-gradient(rgb(223 243 252), rgb(243, 238, 254))" }}>
      <div className="container">
        <div className="row align-items-left">
          
          {/* Left Content */}
          <div className="col-md-6">
            <h2 className="" style={{textAlign:"left", fontSize:"17px", color:""}}>Welcome to EezybreezyU</h2>
            <h3 className=""  style={{textAlign:"left"}}>About Us</h3>
            <p className="mt-4 text-muted">
              At <strong style={{fontWeight:"900"}}>EezybreezyU,</strong> we believe freshness has the power to change the way you feel—at home, at work, or on the road.
             Our story began in <strong style={{fontWeight:"900"}}>2022,</strong> when we set out to create <strong style={{fontWeight:"900"}}>simple, effective, and affordable air fresheners</strong>  for everyday life. What started as a small idea has quickly grown into a trusted name for those who want their surroundings to smell as good as they feel.
             From <strong style={{fontWeight:"900"}}> car fresheners that make every drive enjoyable </strong> to  <strong >home fragrances that keep your living spaces inviting, </strong> our products are designed with care, quality and long-lasting freshness in mind.
              We're not just selling fresheners—we're helping you create little moments of comfort, calm and joy every day.
            </p>

            

           
          </div>

          {/* Right Image */}
          <div className="col-md-6 text-center mt-4 mt-md-0">
            <img
              src="assets_web/images/about.jpg" // <-- Replace with your image path
              alt="Essential Oil"
              className="img-fluid rounded shadow"
              
            />
          </div>
        </div>
      </div>
    </section>
        {/* <section className="topcategory-section centred">
            <div className="auto-container">
                <div className="sec-title">
                    <h2>Top Category</h2>
                    <p></p>
                    <span className="separator" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/icons/separator-1.png)`}}></span>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-4 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                            <figure className="image-box"><img src="assets_web/images/banner/syle-bg-one.jpg" alt="" /></figure>
                            <h5>
                            <NavLink to={`/category/3`}>Home Fragrances</NavLink>
                               
                                </h5>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="200ms" data-wow-duration="1500ms">
                            <figure className="image-box"><img src="assets_web/images/banner/style-bg-two.jpg" alt="" /></figure>
                            <h5>
                            <NavLink to={`/category/4`}>Car Fragrances</NavLink>
                            </h5>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="400ms" data-wow-duration="1500ms">
                            <figure className="image-box"><img src="assets_web/images/banner/syle-bg-one.jpg" alt="" /></figure>
                            <h5>
                                <a href="#">Fruits</a>
                                <NavLink to={`/category/5`}>Hybrid Combo Pack</NavLink>
                                </h5>
                        </div>
                    </div>
                   
                   
                  
                </div>
            </div>
        </section> */}
        <Product />
        <section className="service-section">
            
                <div className="inner-container">
                    <div className="row clearfix">
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-truck"></i></div>
                                    <h3><a href="#">Free Shipping</a></h3>
                                    <p>Free shipping on oder over Rs. 500</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-credit-card"></i></div>
                                    <h3><a href="#">Secure Payment</a></h3>
                                    <p>We ensure secure payment </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-24-7"></i></div>
                                    <h3><a href="#">Customer Support</a></h3>
                                    <p>Available 7 days a week</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-undo"></i></div>
                                    <h3><a href="#">Easy Returns</a></h3>
                                    <p>Raise return within 24 hours refund in 3-7 working days</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           
        </section>
        </div>
            <Footer />
        </>
    );
}

export default Home;
